import { render } from "./GameRulesDice.vue?vue&type=template&id=717b5572&scoped=true"
import script from "./GameRulesDice.vue?vue&type=script&lang=js"
export * from "./GameRulesDice.vue?vue&type=script&lang=js"

import "./GameRulesDice.vue?vue&type=style&index=0&id=717b5572&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717b5572"]])

export default __exports__